// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3hgHR","topBottomGutter":"Layout_topBottomGutter__2FIc2"};